/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ChatHistoryView } from '../models/chat-history-view';
import { QuestionSchema } from '../models/question-schema';
import { AskQuestion } from '../models/ask-question';
@Injectable({
  providedIn: 'root',
})
class TestService extends __BaseService {
  static readonly startChatWsPath = '/chats';
  static readonly getChatHistoryWsPath = '/chats/{chat_id}';
  static readonly askQuestionWsPath = '/chats/{chat_id}/questions';
  static readonly streamAnswerWsPath = '/chats/{chat_id}/questions/{question_id}/stream';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Start a new chat session
   * @param params The `TestService.StartChatWsParams` containing the following parameters:
   *
   * - `api-version`: The requested API version
   *
   * - `X-Correlation-ID`: Used to uniquely identify the HTTP request. This ID is used to correlate the HTTP request between a client and server.
   *
   * - `Authorization`: Api key
   *
   * @return Chat created successfully
   */
  startChatWsResponse(params: TestService.StartChatWsParams): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.apiVersion != null) __params = __params.set('api-version', params.apiVersion.toString());
    if (params.XCorrelationID != null) __headers = __headers.set('X-Correlation-ID', params.XCorrelationID.toString());
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/chats`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * Start a new chat session
   * @param params The `TestService.StartChatWsParams` containing the following parameters:
   *
   * - `api-version`: The requested API version
   *
   * - `X-Correlation-ID`: Used to uniquely identify the HTTP request. This ID is used to correlate the HTTP request between a client and server.
   *
   * - `Authorization`: Api key
   *
   * @return Chat created successfully
   */
  startChatWs(params: TestService.StartChatWsParams): __Observable<string> {
    return this.startChatWsResponse(params).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * Get chat history
   * @param params The `TestService.GetChatHistoryWsParams` containing the following parameters:
   *
   * - `chat_id`:
   *
   * - `api-version`: The requested API version
   *
   * - `X-Correlation-ID`: Used to uniquely identify the HTTP request. This ID is used to correlate the HTTP request between a client and server.
   *
   * - `Authorization`: Api key
   *
   * @return Chat history retrieved successfully
   */
  getChatHistoryWsResponse(params: TestService.GetChatHistoryWsParams): __Observable<__StrictHttpResponse<ChatHistoryView>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.apiVersion != null) __params = __params.set('api-version', params.apiVersion.toString());
    if (params.XCorrelationID != null) __headers = __headers.set('X-Correlation-ID', params.XCorrelationID.toString());
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/chats/${encodeURIComponent(String(params.chatId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ChatHistoryView>;
      })
    );
  }
  /**
   * Get chat history
   * @param params The `TestService.GetChatHistoryWsParams` containing the following parameters:
   *
   * - `chat_id`:
   *
   * - `api-version`: The requested API version
   *
   * - `X-Correlation-ID`: Used to uniquely identify the HTTP request. This ID is used to correlate the HTTP request between a client and server.
   *
   * - `Authorization`: Api key
   *
   * @return Chat history retrieved successfully
   */
  getChatHistoryWs(params: TestService.GetChatHistoryWsParams): __Observable<ChatHistoryView> {
    return this.getChatHistoryWsResponse(params).pipe(
      __map(_r => _r.body as ChatHistoryView)
    );
  }

  /**
   * Ask a question in a chat
   * @param params The `TestService.AskQuestionWsParams` containing the following parameters:
   *
   * - `chat_id`:
   *
   * - `body`:
   *
   * - `api-version`: The requested API version
   *
   * - `X-Correlation-ID`: Used to uniquely identify the HTTP request. This ID is used to correlate the HTTP request between a client and server.
   *
   * - `Authorization`: Api key
   *
   * @return Question created successfully
   */
  askQuestionWsResponse(params: TestService.AskQuestionWsParams): __Observable<__StrictHttpResponse<QuestionSchema>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.body;
    if (params.apiVersion != null) __params = __params.set('api-version', params.apiVersion.toString());
    if (params.XCorrelationID != null) __headers = __headers.set('X-Correlation-ID', params.XCorrelationID.toString());
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/chats/${encodeURIComponent(String(params.chatId))}/questions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<QuestionSchema>;
      })
    );
  }
  /**
   * Ask a question in a chat
   * @param params The `TestService.AskQuestionWsParams` containing the following parameters:
   *
   * - `chat_id`:
   *
   * - `body`:
   *
   * - `api-version`: The requested API version
   *
   * - `X-Correlation-ID`: Used to uniquely identify the HTTP request. This ID is used to correlate the HTTP request between a client and server.
   *
   * - `Authorization`: Api key
   *
   * @return Question created successfully
   */
  askQuestionWs(params: TestService.AskQuestionWsParams): __Observable<QuestionSchema> {
    return this.askQuestionWsResponse(params).pipe(
      __map(_r => _r.body as QuestionSchema)
    );
  }

  /**
   * Stream answer via Server-Sent Events
   * @param params The `TestService.StreamAnswerWsParams` containing the following parameters:
   *
   * - `question_id`:
   *
   * - `chat_id`:
   *
   * - `api-version`: The requested API version
   *
   * - `X-Correlation-ID`: Used to uniquely identify the HTTP request. This ID is used to correlate the HTTP request between a client and server.
   *
   * - `Authorization`: Api key
   */
  streamAnswerWsResponse(params: TestService.StreamAnswerWsParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    if (params.apiVersion != null) __params = __params.set('api-version', params.apiVersion.toString());
    if (params.XCorrelationID != null) __headers = __headers.set('X-Correlation-ID', params.XCorrelationID.toString());
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/chats/${encodeURIComponent(String(params.chatId))}/questions/${encodeURIComponent(String(params.questionId))}/stream`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Stream answer via Server-Sent Events
   * @param params The `TestService.StreamAnswerWsParams` containing the following parameters:
   *
   * - `question_id`:
   *
   * - `chat_id`:
   *
   * - `api-version`: The requested API version
   *
   * - `X-Correlation-ID`: Used to uniquely identify the HTTP request. This ID is used to correlate the HTTP request between a client and server.
   *
   * - `Authorization`: Api key
   */
  streamAnswerWs(params: TestService.StreamAnswerWsParams): __Observable<null> {
    return this.streamAnswerWsResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module TestService {

  /**
   * Parameters for startChatWs
   */
  export interface StartChatWsParams {

    /**
     * The requested API version
     */
    apiVersion?: string;

    /**
     * Used to uniquely identify the HTTP request. This ID is used to correlate the HTTP request between a client and server.
     */
    XCorrelationID?: string;

    /**
     * Api key
     */
    Authorization?: string;
  }

  /**
   * Parameters for getChatHistoryWs
   */
  export interface GetChatHistoryWsParams {
    chatId: string;

    /**
     * The requested API version
     */
    apiVersion?: string;

    /**
     * Used to uniquely identify the HTTP request. This ID is used to correlate the HTTP request between a client and server.
     */
    XCorrelationID?: string;

    /**
     * Api key
     */
    Authorization?: string;
  }

  /**
   * Parameters for askQuestionWs
   */
  export interface AskQuestionWsParams {
    chatId: string;
    body?: AskQuestion;

    /**
     * The requested API version
     */
    apiVersion?: string;

    /**
     * Used to uniquely identify the HTTP request. This ID is used to correlate the HTTP request between a client and server.
     */
    XCorrelationID?: string;

    /**
     * Api key
     */
    Authorization?: string;
  }

  /**
   * Parameters for streamAnswerWs
   */
  export interface StreamAnswerWsParams {
    questionId: string;
    chatId: string;

    /**
     * The requested API version
     */
    apiVersion?: string;

    /**
     * Used to uniquely identify the HTTP request. This ID is used to correlate the HTTP request between a client and server.
     */
    XCorrelationID?: string;

    /**
     * Api key
     */
    Authorization?: string;
  }
}

export { TestService }
